/* eslint-disable */
export function arePointsNear(checkPoint, centerPoint, km = 1) {
    var ky = 40000 / 360;
    var kx = Math.cos((Math.PI * centerPoint.lat) / 180.0) * ky;
    var dx = Math.abs(centerPoint.lng - checkPoint.lng) * kx;
    var dy = Math.abs(centerPoint.lat - checkPoint.lat) * ky;
    return Math.sqrt(dx * dx + dy * dy) <= km;
}
export function trackingVirtualPageViews(path) {
    ga("set", "page", path);
    ga("send", "pageview");
}
export function setDescriptionPage(content) {
    console.log();
    if (!document.querySelector('meta[name="description"]')) {
        const link = document.createElement("meta");
        link.setAttribute("name", "description");
        link.content = content;
        document.getElementsByTagName("head")[0].appendChild(link);
    } else {
        document
            .querySelector('meta[name="description"]')
            .setAttribute("content", content);
    }
}
